import React from 'react';
import { useNavigate } from 'react-router-dom';
import { t } from '@lingui/macro';
import Helmet from '../../components/SEO/Helmet';
import SharedSettingsList from './SharedSettingsList';

export default function SharedSettingsPage() {
  const navigate = useNavigate();
  return (
    <>
      <Helmet
        title={t`Shared Settings`}
        description={t`Manage shared attribute mapping profiles`}
      />
      <SharedSettingsList
        onCreate={() => navigate('/toolkit/shared_settings/new')}
        onEdit={(id) => navigate(`/toolkit/shared_settings/${id}`)}
      />
    </>
  );
}
